// HtmlTemplate.tsx
const getHtmlTemplate = (
    lottieUrl: string,
    tooltipText: string,
    baseUrl: string,
    projectName: string,
    trace: string,
    embedOptions: string
  ): string => {
    return `<body>
  <div id="chatbot-floating-window">
      <div id="chatbot-controls">
          <div id="chatbot-dragbar">
              <div class="left-controls">
                  <button id="chatbot-close-window" onclick="chatbotCloseWindow()"></button>
              </div>
              <div class="right-controls">
                  <button id="chatbot-resize" onclick="toggleChatSize()">
                      <i class="fas fa-expand"></i>
                  </button>
              </div>
          </div>
      </div>
      <iframe id="chatbot-iframe-content"></iframe>
  </div>
  <button id="chatbot-open-window" onclick="chatbotOpenWindow()">
      <dotlottie-player src="${lottieUrl}" background="transparent" speed="1" loop autoplay></dotlottie-player>
      <!-- <dotlottie-player id="claiAnimation" src="https://storage.cloud.google.com/cb_multimedia_content/assets/clai_intro.lottie" background="transparent" autoplay speed="1" loop="false"></dotlottie-player> -->
  </button>
  <div id="chatbot-tooltip">
      ${tooltipText}
      <button id="chatbot-tooltip-close">×</button>
  </div>
  <script>
      let isFullscreen = false;
      const chatbotBubble = document.getElementById('chatbot-open-window');
      // Set iframe source with session ID
      const baseUrl = '${baseUrl}';
      const params = new URLSearchParams({
          project_name: '${projectName}',
          trace: '${trace}',
          embed: 'true',
          embed_options: '${embedOptions}',
      });
  
  
  
      document.getElementById('chatbot-iframe-content').src = \`\${baseUrl}?\${params.toString()}\`;
  
      //Tooltip Behavior
      document.addEventListener('DOMContentLoaded', function() {
          const tooltip = document.getElementById('chatbot-tooltip');
          const player = document.getElementById('claiAnimation');
          
          // Show tooltip after a small delay
          setTimeout(() => {
              tooltip.classList.add('show');
          }, 1000);
  
          // Hide tooltip after 30 seconds
          setTimeout(() => {
              tooltip.classList.remove('show');
          }, 60000);
  
          // Hide tooltip when chat button is clicked
          document.getElementById('chatbot-open-window').addEventListener('click', () => {
              tooltip.classList.remove('show');
          });
  
          document.getElementById('chatbot-tooltip-close').addEventListener('click', () => {
              tooltip.classList.remove('show');
          });
      });
  
      // Chatbot Window interactions 
      document.getElementById('chatbot-open-window').addEventListener('click', function () {
          chatbotOpenWindow();
      });
  
      document.getElementById('chatbot-close-window').addEventListener('click', function () {
          chatbotCloseWindow();
      });
  
      // Chatbot UI Functions
      function toggleChatSize() {
          const floatingWindow = document.getElementById('chatbot-floating-window');
          const chatbotControls = document.getElementById('chatbot-controls');
          const resizeBtn = document.querySelector('#chatbot-resize i');
          const body = document.body;
  
          if (floatingWindow.classList.contains('fullscreen')) {
              floatingWindow.classList.remove('fullscreen');
              chatbotControls.classList.remove('fullscreen');
              resizeBtn.classList.remove('fa-compress');
              resizeBtn.classList.add('fa-expand');
              body.classList.remove('scroll-lock');
              isFullscreen = false;
          } else {
              floatingWindow.classList.add('fullscreen');
              chatbotControls.classList.add('fullscreen');
              resizeBtn.classList.remove('fa-expand');
              resizeBtn.classList.add('fa-compress');
              if (floatingWindow.classList.contains('show')) {
                  body.classList.add('scroll-lock');
              }
              isFullscreen = true;
          }
      }
  
      // Chatbot Open/Close Functions
      function chatbotOpenWindow() {
          const floatingWindow = document.getElementById('chatbot-floating-window');
          const body = document.body;
          setTimeout(() => {
              floatingWindow.classList.add('show');
              if (window.innerWidth <= 767) {
                  disableScroll();
                  // document.body.style.overflow = 'hidden';
              } else { 
                  if (floatingWindow.classList.contains('fullscreen')){
                      body.classList.add('scroll-lock');
                      isFullscreen = true;
                  }
              }
              
          }, 10); // Small delay to ensure the transition works
          document.getElementById('chatbot-open-window').style.display = 'none';
      };
  
      function chatbotCloseWindow() {
          const floatingWindow = document.getElementById('chatbot-floating-window');
          const body = document.body;
  
          floatingWindow.classList.add('hide');
          body.classList.remove('scroll-lock');
          
          setTimeout(() => {
              document.getElementById('chatbot-open-window').style.display = 'block';
              floatingWindow.classList.remove('show');
              floatingWindow.classList.remove('hide');
              if (window.innerWidth <= 767) {
                  enableScroll();
                  // document.body.style.overflow = '';
              }
          }, 200); // Match the transition duration
      };
  
  
      // Function to disable scrolling on the parent document
      function disableScroll() {
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
      }
  
      // Function to enable scrolling on the parent document
      function enableScroll() {
          document.body.style.overflow = '';
          document.body.style.position = '';
      }
  
  </script>
  
  <!-- Include Font Awesome for the icon -->
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  <script src="https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js"></script>
  <script src="https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.mjs" type="module"></script>
  </body>`;
  };
  
  export default getHtmlTemplate;